import { meaningfulPostTitle, untitledPostLabel } from './post-title';

/**
 * The breadcrumb leaf for a post opened in the editor: its title, else the
 * caption's first line cut at a word boundary. The breadcrumb already fades
 * whatever still overflows, so a hard 48-character slice plus "..." made a
 * phone header end mid-word and then fade on top of the dots.
 */
export function postBreadcrumbLabel(
  post: { title?: string | null; content?: string | null },
  maxLength = 40,
): string {
  const title = meaningfulPostTitle(post.title);
  if (title) return title;
  return captionHeadline(post.content, maxLength) ?? 'Post';
}

function captionHeadline(content: string | null | undefined, maxLength: number): string | null {
  const firstLine = (content ?? '')
    .split('\n')
    .map((line) => line.trim())
    .find(Boolean);
  if (!firstLine) return null;
  if (firstLine.length <= maxLength) return firstLine;
  const cut = firstLine.slice(0, maxLength + 1);
  const space = cut.lastIndexOf(' ');
  const head = (space > maxLength / 2 ? cut.slice(0, space) : cut.slice(0, maxLength)).replace(
    /[\s,.;:!?–—-]+$/u,
    '',
  );
  return `${head}…`;
}

export function postHeaderTitle(
  post: { title?: string | null; content?: string | null; created_at?: string | null },
  maxLength = 60,
): string {
  const title = meaningfulPostTitle(post.title);
  if (title) return title;
  return captionHeadline(post.content, maxLength) ?? untitledPostLabel(post.created_at);
}
